import { Checkbox } from '@cof/plastic-components';
import { styled, css } from 'styled-components';

export const StyledLightCheckbox = styled(Checkbox)`
    ${({ theme }: any) => css`
        & ~ .styled-checkbox {
            border-color: ${theme.colors.global.white};
            background-color: ${theme.colors.capitalOne.blue750};
        }

        &:checked {
            & ~ .styled-checkbox {
                background-color: ${theme.colors.global.white};
                border-color: ${theme.colors.global.white};

                & svg {
                    color: ${theme.colors.global.black};
                    @media (forced-colors: active) {
                        color: ${theme.colors.global.white};
                    }
                }
            }
        }
    `};
`;
